<template lang="pug">
    div
        slot(v-bind:data="transform(data || dataArray)")
</template>

<script>
export default {
    name: 'VDataTransformer',
    props: {
        data: {
            type: Object,
            default() {
                return null;
            }
        },
        dataArray: {
            type: Array,
            default: null
        },
        transform: {
            type: Function,
            default: () => null
        }
    }
};
</script>